import { gql } from '@apollo/client';

export const GET_FUNNEL_QUERY_PARAMS = gql`
  query GetFunnelQueryParams($token: String!) {
    funnelQueryParams(token: $token) {
      params {
        email
        phone
        zipCode
        lastName
        firstName
        utilityId
        inviteCode
        meterNumber
        accountNumber
        partnerSource
        preferredEnrollment
        serviceAddressZip
        serviceAddressCity
        serviceAddressState
        annualizedUsageEstimate
        serviceAddressStreetOne
        serviceAddressStreetTwo
        secondaryAccountIdentifier
      }
      error
    }
  }
`;
